import { useState } from "react";
import api from "../../api";
import toast from "react-hot-toast";

export default function ZebrafishForm() {
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        user_type: "",
        principal_investigator: "",
        institution: "",
        department: "",
        register_number: "",
        employment_number: "",
        contact_number: "",
        email: "",
        guide: "",
        project_title: "",
        iaec_number: "",
        zebrafish_count: "",
        housing_requirements: "",
        experimental_type: "",
        preferred_date: "",
        time_hour: "",
        time_minute: "",
        time_ampm: "am",
        duration: "",
        payment_file: null,
    });

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;

        if (name === "contact_number") {
            if (!/^\d*$/.test(value) || value.length > 10) return;
        }

        if (name === "zebrafish_count") {
            if (!/^\d*$/.test(value)) return;
        }

        if (name === "time_hour" || name === "time_minute") {
            if (!/^\d*$/.test(value) || value.length > 2) return;
        }

        setFormData({
            ...formData,
            [name]: type === "file" ? files[0] : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.user_type) {
            toast.error("Please select User Type");
            return;
        }

        setSubmitting(true);

        try {
            const payload = new FormData();

            Object.entries(formData).forEach(([key, value]) => {
                if (value !== "" && value !== null) {
                    payload.append(key, value);
                }
            });

            const res = await api.post(
                "/api/zebrafish-request/submit",
                payload,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            toast.success(res.data.message || "Request submitted successfully!");

            setFormData({
                user_type: "",
                principal_investigator: "",
                institution: "",
                department: "",
                register_number: "",
                employment_number: "",
                contact_number: "",
                email: "",
                guide: "",
                project_title: "",
                iaec_number: "",
                zebrafish_count: "",
                housing_requirements: "",
                experimental_type: "",
                preferred_date: "",
                time_hour: "",
                time_minute: "",
                time_ampm: "am",
                duration: "",
                payment_file: null,
            });

            e.target.reset();
        } catch (err) {
            const msg =
                err.response?.data?.message ||
                Object.values(err.response?.data?.errors || {})[0]?.[0] ||
                "Submission failed";

            toast.error(msg);
        } finally {
            setSubmitting(false);
        }
    };

    const isExternal = formData.user_type === "External";
    const isStudent = formData.user_type === "Internal Students";
    const isFaculty = formData.user_type === "Internal Faculty";

    const renderForm = () => (
        <div className="card shadow-lg">
            <div className="card-body p-4">
            <h3 className="text-center fw-bold mb-4">
                Zebrafish Request Form
            </h3>

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                <label className="form-label fw-bold">
                    User Type <span className="text-danger">*</span>
                </label>

                {["External", "Internal Faculty", "Internal Students"].map((type) => (
                    <div className="form-check" key={type}>
                    <input
                        type="radio"
                        className="form-check-input"
                        id={type}
                        name="user_type"
                        value={type}
                        checked={formData.user_type === type}
                        onChange={handleChange}
                        required
                    />
                    <label className="form-check-label cursor-pointer" htmlFor={type}>
                        {type}
                    </label>
                    </div>
                ))}
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Principal Investigator <span className="text-danger">*</span></label>
                    <input
                    type="text"
                    name="principal_investigator"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                    required
                    />
                </div>

                {isExternal && (
                    <div className="col-md-6 mb-3">
                    <label className="form-label">Institution <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="institution"
                        maxLength={100}
                        className="form-control"
                        onChange={handleChange}
                        required
                    />
                    </div>
                )}

                {isStudent && (
                    <div className="col-md-6 mb-3">
                    <label className="form-label">Register Number <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="register_number"
                        maxLength={100}
                        className="form-control"
                        onChange={handleChange}
                        required
                    />
                    </div>
                )}

                {isFaculty && (
                    <div className="col-md-6 mb-3">
                    <label className="form-label">Employment Number <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        name="employment_number"
                        maxLength={100}
                        className="form-control"
                        onChange={handleChange}
                        required
                    />
                    </div>
                )}
                </div>

                <div className="mb-3">
                <label className="form-label">Department / Designation <span className="text-danger">*</span></label>
                <input
                    type="text"
                    name="department"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                    required
                />
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Contact Number <span className="text-danger">*</span></label>
                    <input
                    type="text"
                    inputMode="numeric"
                    name="contact_number"
                    value={formData.contact_number || ""}
                    pattern="[0-9]*"
                    maxLength={10}
                    className="form-control"
                    onChange={handleChange}
                    required
                    />
                </div>

                <div className="col-md-6 mb-3">
                    <label className="form-label">Email <span className="text-danger">*</span></label>
                    <input
                    type="email"
                    name="email"
                    className="form-control"
                    onChange={handleChange}
                    required
                    />
                </div>
                </div>

                <div className="mb-3">
                <label className="form-label">Guide <span className="text-danger">*</span></label>
                <input
                    type="text"
                    name="guide"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                    required
                />
                </div>

                <div className="mb-3">
                <label className="form-label">Project Title <span className="text-danger">*</span></label>
                <input
                    type="text"
                    name="project_title"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                    required
                />
                </div>

                <div className="mb-3">
                <label className="form-label">IAEC Approval Number</label>
                <input
                    type="text"
                    name="iaec_number"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                />
                </div>

                <div className="mb-3">
                <label className="form-label">Number of Zebrafish Required <span className="text-danger">*</span></label>
                <input
                    type="number"
                    name="zebrafish_count"
                    className="form-control"
                    onChange={handleChange}
                    required
                />
                </div>

                <div className="mb-3">
                <label className="form-label">Housing / Tank Requirements</label>
                <input
                    type="text"
                    name="housing_requirements"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                />
                </div>

                <div className="mb-3">
                <label className="form-label">
                    Type of Experimental Procedure <span className="text-danger">*</span>
                </label>
                <input
                    type="text"
                    name="experimental_type"
                    maxLength={100}
                    className="form-control"
                    onChange={handleChange}
                    required
                />
                </div>

                <div className="row">
                <div className="col-md-6 mb-3">
                    <label className="form-label">Preferred Date <span className="text-danger">*</span></label>
                    <input
                    type="date"
                    name="preferred_date"
                    min={new Date().toISOString().split("T")[0]}
                    className="form-control"
                    onChange={handleChange}
                    required
                    />
                </div>

                <div className="col-md-6 mb-3">
                    <div>
                        <label className="form-label">Preferred Time <span className="text-danger">*</span></label>
                    </div>
                    <div className="d-flex gap-2">
                        <input
                        type="text"
                        name="time_hour"
                        value={formData.time_hour}
                        placeholder="HH"
                        maxLength={2}
                        className="form-control"
                        onChange={handleChange}
                        required
                        />
                        <input
                        type="text"
                        name="time_minute"
                        value={formData.time_minute}
                        placeholder="MM"
                        maxLength={2}
                        className="form-control"
                        onChange={handleChange}
                        required
                        />
                        <select
                        name="time_ampm"
                        className="form-select"
                        onChange={handleChange}
                        >
                        <option value="am">AM</option>
                        <option value="pm">PM</option>
                        </select>
                    </div>
                </div>
                </div>

                <div className="mb-3">
                <label className="form-label">
                    Duration of Facility Use <span className="text-danger">*</span>
                </label>
                <input
                    type="text"
                    name="duration"
                    className="form-control"
                    onChange={handleChange}
                    required
                />
                </div>

                {isExternal && (
                <div className="mb-3">
                    <label className="form-label">
                    Upload Payment Details <span className="text-danger">*</span>
                    </label>
                    <input
                    type="file"
                    name="payment_file"
                    className="form-control"
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={handleChange}
                    required
                    />
                </div>
                )}

                <button className="btn btn-primary w-100 py-2" type="submit" disabled={submitting}>
                    {submitting ? "Submitting..." : "Submit Request"}
                </button>
            </form>
            </div>
        </div>
    );

    return (
        <>
            <div className="row justify-content-center">
                <div className="col-12">
                    {renderForm()}
                </div>
            </div>
        </>
    );
}
